module.exports = __webpack_public_path__ + "img/logo.a249f6ca.png";